import { API } from '../../shared/constants/constants';

export const duplicateServiceLog = async (id) => {
  await API.post(`/service/${id}/duplicate`);
};

export const duplicateMediaInteraction = async (id) => {
  await API.post(`/issue/${id}/duplicate`);
};

export const duplicateEngagementLog = async (id) => {
  await API.post(`/engagement/${id}/duplicate`);
};

export const getFlatIssueById = async (id) => {
  return await API.get(`issue/${id}/flat`);
};

export const getFlatServiceById = async (id) => {
  return await API.get(`service/${id}/flat`);
};

export const getFlatEngagementById = async (id) => {
  return await API.get(`engagement/${id}/flat`);
};
